(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/actions.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/actions.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.views.Actions = Marionette.View.extend({
    template: function template(data) {
      return svs.player_login.templates.dummy(data);
    },
    onAttach: function onAttach() {
      var returnUrl = this.model.get('returnUrl') || svs.utils.urlMapping.get('startPage'),
          self = this;

      switch (this.model.get('action')) {
        case 'show_national_suspension_message':
          svs.accountservices.national_suspension_message.showNationalSuspensionMessage(function () {
            svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl, svs.utils.urlMapping.get('startPage')));
          });
          break;

        case 'show_national_suspension_message_then_password_redirect':
          svs.accountservices.national_suspension_message.showNationalSuspensionMessage(function () {
            svs.utils.form.postToUrl("".concat(svs.utils.urlMapping.get('setPasswordHome'), "?returnUrl=").concat(encodeURIComponent(returnUrl || svs.utils.urlMapping.get('startPage'))), {
              password: self.model.get('password')
            });
          });
          break;

        case 'password_redirect':
          svs.utils.form.postToUrl("".concat(svs.utils.urlMapping.get('setPasswordHome'), "?returnUrl=").concat(encodeURIComponent(returnUrl || svs.utils.urlMapping.get('startPage'))), {
            password: this.model.get('password')
          });
          break;

        case 'show_suspension':
          svs.components.suspension_message.showSuspensionMessage(function () {
            svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl, svs.utils.urlMapping.get('startPage')));
          });
          break;

        case 'show_suspension_reminder':
          svs.components.suspension_message.showSuspensionEndMessage(function () {
            svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl, svs.utils.urlMapping.get('startPage')));
          });
          break;

        default:
          svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl, svs.utils.urlMapping.get('startPage')));
      }
    }
  });
})(Backbone, _, svs);
 })(window);